// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"ModalComponent_mainContainer__2IBTU","title":"ModalComponent_title__sHpWg","paper":"ModalComponent_paper__2zrxc","actionBtn":"ModalComponent_actionBtn__3dyHD"};